import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { doorCostApi } from 'features/suppliers-management/door-cost/query';
import { TDoorCostState } from 'features/suppliers-management/door-cost/types';

const initialState: TDoorCostState = {
  doorCosts: [],
  doorCostsTotalCount: 0,
  doorCostDetail: null,
};

const doorCostSlice = createSlice({
  name: 'doorCost',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { GetAllDoorCosts, GetDoorCostDetail } = doorCostApi.endpoints;

    builder.addMatcher(GetAllDoorCosts.matchFulfilled, (state, action) => {
      state.doorCosts = action.payload?.data || [];
      state.doorCostsTotalCount =
        action.payload?.pagination?.total_elements || 0;
    });
    builder.addMatcher(
      isAnyOf(GetAllDoorCosts.matchRejected, GetAllDoorCosts.matchPending),
      state => {
        state.doorCosts = [];
        state.doorCostsTotalCount = 0;
      }
    );

    builder.addMatcher(GetDoorCostDetail.matchFulfilled, (state, action) => {
      state.doorCostDetail = action.payload?.data || null;
    });
    builder.addMatcher(
      isAnyOf(GetDoorCostDetail.matchRejected, GetDoorCostDetail.matchPending),
      state => {
        state.doorCostDetail = null;
      }
    );
  },
});

export default doorCostSlice.reducer;
